<template lang="pug" src="./custom-contact-form-tab.pug"></template>

<script>
import ApptForm from 'components/forms/appt-req-form/appt-req-form'
import ContactForm from 'components/forms/contact-form/contact-form'
import Icon from 'components/icon/icon'
import Refer from 'components/forms/refer-form/refer-form'
import Survey from 'components/forms/survey-form/survey-form'

export default {
  props: ['props', 'app'],
  components: {
    ApptForm,
    ContactForm,
    Icon,
    Refer,
    Survey
  },
  methods: {
    showContent (i) {
      this.$store.dispatch('VIEW_TYPES', i)
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-contact-form-tab.vue?3fe91a80